import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchProductLink } from 'redux/catalog/actions';

import { Checkbox } from 'semantic-ui-react';

import './ShowProductPriceCheckbox.css';


class ShowProductPriceCheckbox extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    productId: PropTypes.number.isRequired,
    showPrice: PropTypes.bool,
  };

  static defaultProps = {
    showPrice: null,
  };

  state = {
    firstChange:  null,
    currentShowPrice: null,
  };

  componentDidMount() {
    this.setState({ currentShowPrice: this.props.showPrice });
  }

  componentDidUpdate(prevProps, prevState) {
    const { productId, patchProductLink } = this.props;
    const { currentShowPrice, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentShowPrice !== this.state.currentShowPrice
    ) {
      patchProductLink(productId, { show_price: currentShowPrice });
    }
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentShowPrice: !this.state.currentShowPrice,
    });
  }

  render() {
    const { showPrice } = this.props;
    const { firstChange, currentShowPrice } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="show-product-price-checkbox__component">
            <Checkbox
              checked={firstChange ? currentShowPrice : showPrice}
              onChange={this.onCheckboxChange}
            />
            <div className="label">
              {t("Show price on public store page")}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchProductLinkError: state.catalogReducer.patchProductLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(ShowProductPriceCheckbox);
